module.exports = __webpack_public_path__ + "img/consultation_e.10a5326e.png";